import React from 'react';
import { Form, Select } from 'antd';
import _ from 'lodash';
import PropTypes from 'prop-types';
import InputRequired from './InputRequired';

const FormItem = Form.Item;
const { Option } = Select;

// Input type maybe text or password
export default function SelectInput(props) {
  const {
    getFieldDecorator,
    fieldName,
    list,
    label,
    placeholder,
    disable,
    mode,
    defaultValue,
    loading,
    required
  } = props;
  const labelConvert = required ? <InputRequired name={label} /> : label;
  return (
    <FormItem
      label={labelConvert}
    >
      {getFieldDecorator(fieldName, {
        initialValue: defaultValue,
        rules: [
          { required, message: `Vui lòng chọn ${label}` }
        ]
      })(
        <Select
          disabled={disable}
          loading={loading}
          mode={mode}
          optionFilterProp="children"
          placeholder={placeholder}
          showSearch
          style={{ width: '100%' }}
        >
          {_.map(list, (item, index) => (
            <Option key={index} value={item.value}>{_.truncate(item.name, { length: 60, separator: '...' })}</Option>
          ))}
        </Select>
      )}
    </FormItem>
  );
}

SelectInput.propTypes = {
  getFieldDecorator: PropTypes.objectOf(PropTypes.any).isRequired,
  fieldName: PropTypes.string.isRequired,
  list: PropTypes.objectOf(PropTypes.any).isRequired,
  label: PropTypes.string.isRequired,
  mode: PropTypes.string.isRequired,
  placeholder: PropTypes.objectOf(PropTypes.any),
  disable: PropTypes.bool,
  defaultValue: PropTypes.string,
  loading: PropTypes.bool,
  required: PropTypes.bool
};

SelectInput.defaultProps = {
  disable: false,
  defaultValue: '',
  placeholder: '',
  loading: false,
  required: false
};
